import { Controller, useFormContext } from "react-hook-form";
import { Flex } from "../../../../../components/Flex";
import { Text } from "../../../../../components/Text";
import { useTranslation } from "react-i18next";
import { TestIDs } from "../../../../../tests/types/testIds";
import styled from "styled-components";
import { Spacing } from "../../../../../theme/Spacing";
import { AtiraIcon } from "../../../../../components/AtiraIcon";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons/faEllipsis";
import { AtiraSelect } from "../../../../../components/AtiraSelect";
import { CreateChatbotDto } from "../../../../../model/chatbot/dto/CreateChatbotDto";
import { UpdateChatbotDto } from "../../../../../model/chatbot/dto/UpdateChatbotDto";
import { AtiraColorPicker } from "../../../../../components/AtiraColorPicker";
import { ChatbotPosition } from "../../../../../model/chatbot/types/Chatbot.position.enum";

const Container = styled(Flex)`
  gap: ${Spacing.xl};
  width: 50%;
  flex-wrap: wrap;
  align-self: flex-start;
  flex-direction: column;
`;

export const SettingsAIChatBotStepCustomization = () => {
  const { control, watch, setValue } = useFormContext<
    CreateChatbotDto | UpdateChatbotDto
  >();
  const { t } = useTranslation();

  return (
    <Container>
      <Flex alignItems="center" gap="s">
        <AtiraIcon icon={faEllipsis} color="main" size="xl" />

        <Text fontSize="l" fontWeight={"bold"} color="main">
          {t("settings.aiChatbot.sections.extraActions.title")}
        </Text>
      </Flex>

      <Flex flexDirection="column" gap="l">
        <Controller
          name="config.position"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <AtiraSelect
              onChange={onChange}
              value={value}
              className={TestIDs.chatbot.drawer.createEdit.fields.position.open}
              title={t("settings.aiChatbot.config.position.title")}
              info={t("settings.aiChatbot.config.position.info")}
              valid={!error}
              errorMessage={error?.message}
              options={Object.values(ChatbotPosition).map((position) => ({
                label: t(
                  `settings.aiChatbot.config.position.options.${position.toLowerCase()}`,
                ),
                value: position,
                "data-testid":
                  TestIDs.chatbot.drawer.createEdit.fields.position.option(
                    position,
                  ),
              }))}
            />
          )}
        />

        <Controller
          name="config.color"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <AtiraColorPicker
              onChange={onChange}
              value={value}
              className={TestIDs.chatbot.drawer.createEdit.fields.color}
              title={t("settings.aiChatbot.config.color.title")}
              info={t("settings.aiChatbot.config.color.info")}
              valid={!error}
              errorMessage={error?.message}
            />
          )}
        />
      </Flex>
    </Container>
  );
};
